module.exports = __webpack_public_path__ + "js/1.21579c81.worker.js"